
import TableList from "@components/templates/tablelist";
import { HttpRevokeBilling,HttpNoNeedBilling,HttpGetbillPeriodList } from "@/service/newbigaccount";
import { HttpGetStorageListt, HttpGetPaybillPeriodList } from "@/service/chargescalc";
import { HttpServiceWarehouseList } from "@/service/basicdata"
import { mapState, mapGetters } from "vuex";
import comExcel from '../../excelalert.vue'

import mixin from '../../mixin'

export default {
    mixins: [TableList,mixin],
    components: {
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                    EQ_status:null,
                    EQ_promotionType:null,
                    IN_id:null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            peroList:[],
        };
    },

    created() {
        this.revokeSymbal = this.handleAuth("fbb.billing.revokeBilling");
        this.noneedSymbal = this.handleAuth("fbb.billing.noNeedBilling");
        HttpGetPaybillPeriodList({
            page:1,
            rows:10000,
        }).then(res=>{
            this.peroList = res.data.content
        });
    },

    methods: {
        ajaxRequest: HttpGetStorageListt,
        // toolsRender() {
        //     return <Alert class="margin-bottom-10" show-icon>
        //     仓储费原计费体积单位为立方英尺（包仓除外），自2023年1月12日开始切换为立方米，请检查并更新报价，2023年1月12日之前生成的费用如需按立方米结算，可手动重新结算。
        // </Alert>
        // },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "export":
                    // this.handleWebfs(
                    //     process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingPayableStorageItem/export", this.formData,
                    //     {
                    //         executor: "request",
                    //         download: true,
                    //         method: 'get'
                    //     }
                    // );
                    this.export();
                    break;
                case "revoke":
                    this.operate={
                        show: true,
                        alert: "warning",
                        params:{ids:params, operationObject:'BILLING_STORAGE_ITEM', billingChannel: 'PAYABLE'},
                        title: "重新结算",
                        ajaxRequest:HttpRevokeBilling
                    }
                    break;
                case "noneed":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, operationObject:'BILLING_STORAGE_ITEM', billingChannel:'PAYABLE'},
                        title: "无需结算",
                        ajaxRequest:HttpNoNeedBilling
                    }
                    break;
            }
        },
        export(){
            const {search}=this.formData
                // const orgWarehouseId = search.EQ_orgWarehouseCode ? this.getBillcusWareList.filter(item => item.attach.code === search.EQ_orgWarehouseCode)[0].value : `''`;
                const startAt = search.BT_createdAt ? search.BT_createdAt.slice(0,10) : `''`;
                const endAt = search.BT_createdAt ? search.BT_createdAt.slice(13) : `''`;
                const complete_start_at = search.BT_completeDate ? search.BT_completeDate.slice(0,10) : `''`;
                const complete_end_at = search.BT_completeDate ? search.BT_completeDate.slice(13) : `''`;
                const fetch_start_at = search.BT_fetchDate ? search.BT_fetchDate.slice(0,10) : `''`;
                const fetch_end_at = search.BT_fetchDate ? search.BT_fetchDate.slice(13) : `''`;
                const searchItem = {
                    isManage: 1,
                    type: 1,
                    context_id: global.SYSID,
                    organization_id: search.EQ_organizationId || `''`,
                    bill_no: search.EQ_billNo || `''`,
                    batch_no: search.EQ_batchNo || `''`,
                    bill_period_id: search.EQ_billPeriodId || `''`,
                    org_warehouse_id: search.EQ_warehouseId || `''`,
                    line_id: search.EQ_lineId || `''`,
                    sku: search.CN_sku || `''`,
                    trade_no: search.EQ_tradeNo || `''`,
                    expense_category_customize_code: search.CN_expenseCategoryCustomizeCode || `''`,
                    inventory_type: search.EQ_inventoryType || `''`,
                    billing_category_name_level: search.CN_billingCategoryNameLevel || `''`,
                    start_at: startAt || `''`,
                    end_at: endAt || `''`,
                    complete_start_at: complete_start_at || `''`,
                    complete_end_at: complete_end_at || `''`,
                    fetch_start_at: fetch_start_at || `''`,
                    fetch_end_at: fetch_end_at || `''`,
                    bill_status: search.EQ_billStatus || `''`,
                }
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                    {args:JSON.stringify(searchItem), template_id: 10017},
                    {
                        executor: "request",
                        download: true,
                        method: "post",
                    }
                )
                .then((res) => {
                    this.operate = {
                      title: '查询条件导出',
                      show: true,
                      width: 560,
                      component: "comExcel",
                      fileId: res.data.id,
                      showFooter: false
                }})
                .catch((err) => {
                    // this.$VMessage.error(err.message);
                });
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList','getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
                {
                    name: "重新结算",
                    operate: "revoke",
                    show:this.revokeSymbal,
                    more:true,
                    batch:true,
                },
                {
                    name: "无需结算",
                    operate: "noneed",
                    show:this.noneedSymbal,
                    more:true,
                    batch:true,
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            let widthStyle = 'width: 200px;'
            return  [
                {
                    label: "客户组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'EQ_warehouseId',
                    options: this.warehouseList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '账单编号',
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: 'SKU',
                    tag: 'vInput',
                    key: 'CN_sku',
                    style: widthStyle,
                },
                {
                    label: '交易参考号',
                    tag: 'vInput',
                    key: 'EQ_tradeNo',
                    style: widthStyle,
                },
                {
                    label: '库存类型',
                    tag: 'vSelect',
                    key: 'EQ_inventoryType',
                    options: this.getInventoryTypeList,
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                {
                    label: '账期',
                    tag: 'vSelect',
                    key: 'EQ_billPeriodId',
                    options: this.peroList.map(item=>{
                        return {
                            label:item.code,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                // {
                //     label: '计费项',
                //     tag: 'vInput',
                //     key: 'EQ_billingCategoryNameLevel',
                // },
                {
                    label: '项目',
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                    style: widthStyle,
                },
                {
                    label: '批次号',
                    tag: 'vInput',
                    key: 'EQ_batchNo',
                    style: widthStyle,
                },
                // {
                //     label: '账期状态',
                //     tag: 'vSelect',
                //     key: 'EQ_billNo',
                //     options: this.getBillTypeList,
                //     props:{
                //         filterable:true,
                //     },
                // },
                {
                    label: '报价模板代码',
                    tag: 'vInput',
                    key: 'CN_expenseCategoryCustomizeCode',
                    style: widthStyle,
                },
                {
                    label: '计费项',
                    tag: 'vInput',
                    key: 'CN_billingCategoryNameLevel',
                    style: widthStyle,
                },
                {
                    label: '快照日期',
                    tag: 'vDatepicker',
                    key: 'BT_fetchDate',
                    props:{
                        options: this.options,
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle,
                },
                {
                    label: '结算日期',
                    tag: 'vDatepicker',
                    key: 'BT_completeDate',
                    props:{
                        options: this.options,
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle,
                },
                {
                    label: "创建日期",
                    tag: "vDatepicker",
                    key: "BT_createdAt",
                    props: {
                        options: this.options,
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false,
                    },
                    style: widthStyle,
                },
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '客户组织/仓库',
                    // render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId),
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.organizationName}</div>
                            <div>{this.findRenderLabel(this.warehouseList, row.warehouseId)||'--'}</div>
                            {/* <div>{row.orgWarehouseCode}</div> */}
                        </div>
                    }
                },
                // {
                //     title: '仓库',
                //     width: 150,
                //     render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row.warehouseId),
                // },
                {
                    title: '交易参考号',
                    render: (h, { row }) => {
                        return <div>{row.tradeNo || '--'}</div>
                    }
                },
                {
                    title: '账单编号/账期',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.billNo || '--'}</div>
                            <div>{row.billPeriodCode || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: '账期',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>
                //         <div>{row.billPeriodCode || '--'}</div>
                //         </div>

                //     },
                // },
                {
                    title: '报价模板代码/计费项',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.expenseCategoryCustomizeCode || '--'}({row.version})</div>
                            <div>{row.billingCategoryNameLevel || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: '计费项',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>{row.billingCategoryNameLevel || '--'}</div>
                //     }
                // },
                {
                    title: 'SKU/项目/SKU尺寸',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.sku || '--'}</div>
                            <div>{this.findRenderLabel(this.getCusproductList, row.lineId)}</div>
                            <div>{row.length || '--'}*{row.width || '--'}*{row.height || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: 'SKU尺寸',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>{row.length || '--'}*{row.width || '--'}*{row.height || '--'}</div>
                //     }
                // },
                {
                    title: '单价*数量*计费量',
                    render: (h, { row }) => {
                        return <div>{row.price || '--'}*{row.qty || '--'}*{row.volume || '--'}</div>
                    }
                },
                {
                    title: '费用',
                    render: (h, { row }) => {
                        return <div>{row.totalCost || '--'}</div>
                    }
                },
                // {
                //     title: '项目',
                //     width: 150,
                //     render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId),
                // },
                {
                    title: '库存快照日期/批次号',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.fetchDate || '--'}</div>
                            <div>{row.batchNo || '--'}</div>
                        </div>
                    }
                },
                // {
                //     title: '批次号',
                //     width: 150,
                //     render: (h, { row }) => {
                //         return <div>{row.batchNo || '--'}</div>
                //     }
                // },
                {
                    title: '存储天数',
                    render: (h, { row }) => {
                        return <div>{row.days || '--'}</div>
                    }
                },
                {
                    title: '结算时间/创建时间',
                    width: 150,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.completeDate || '--'}</div>
                            <div>{row.createdAt || '--'}</div>
                        </div>
                    }
                },
            ];
        },

    },

};
